import { common, customField, mstCommon } from '@libs/domain';
import { Item } from '@ps-smart-cp/ppfw-client';

const customFieldBasicSettingFieldConfig = {
  isUsed: Item.of(common.names.isUsed, common.attributes.isUsed),
  displayName: Item.of(mstCommon.names.displayName, mstCommon.attributes.displayName),
  attribute: Item.of(customField.names.attribute, customField.attributes.attribute),
  codeDigits: Item.of(mstCommon.names.codeDigits, mstCommon.attributes.codeDigits.replaceRequired(false)),
};

const customFieldLedgerSettingFieldConfig = {
  displayOrder: Item.of(customField.names.displayOrder, customField.attributes.displayOrder),
  customField: Item.of(customField.names.customField, customField.attributes.customField),
  isRequired: Item.of(customField.names.isRequired, customField.attributes.isRequired),
};

export { customFieldBasicSettingFieldConfig, customFieldLedgerSettingFieldConfig };
